// extracted by mini-css-extract-plugin
export default {"employeeAvatar":"employee-avatar_employeeAvatar__Cu4ZB"};